export default "__VITE_ASSET__CPa$ABP1__"